import React from 'react';
import MonitorSelect from '@op/components/FilterCommon/widgets/MonitorSelect';
import {
  MonitorSelectType,
  TopicType,
} from '@op/components/FilterCommon/types';
import TopicSelect from '@op/components/FilterCommon/widgets/TopicSelect';
import './index.scss';
import { defaultFilterValue } from '@op/components/FilterCommon/constants';

const componentMap = {
  MonitorSelect,
  TopicSelect,
};

const defaultValue = defaultFilterValue();

export default function FilterInfo({
  text,
  filterName,
  filterProps,
}: {
  text: string;
  filterName: 'MonitorSelect' | 'TopicSelect';
  filterProps: MonitorSelectType | TopicType;
}) {
  const Component = componentMap[filterName];

  return (
    <div className="dbo-monitoring-select">
      <div className="dbo-monitoring-select-label">{text}</div>
      <div className="dbo-monitoring-select-content">
        <Component
          {...filterProps}
          filterValue={defaultValue}
          defaultValue={defaultValue}
          oriDefaultFilter={defaultValue}
          boxClassName="dbo-select-hide-checkbox"
        ></Component>
      </div>
    </div>
  );
}
